<template>
  <ModalDialog
    ref="dlgEditEventChoice"
    :title="dlgEditChoiceTitle"
    :labelCancel="$t('general.cancel')"
    :labelOk="$t('general.submit')"
    @ok="updateChoice"
    @cancel="onCancel"
  >
    <div class="text-small">{{ $t('event.dlgSectionTitle') }}</div>
    <edit-event-choice
      ref="dlgEventChoice"
      :guests="eventChoice.guests"
      v-model="eventChoice"
    />
  </ModalDialog>
</template>

<script>
import EditEventChoice from '@/components/UI/EditEventChoice';
import sprintf from '@/shared/sprintf';
import { mapState } from 'vuex';

export default {
  name: 'ModalEventChoice',

  components: {
    EditEventChoice,
  },

  data() {
    return {
      participant: null,
      eventChoice: {
        answer: -1,
        guests: 1,
        comment: null,
      },
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),
    dlgEditChoiceTitle() {
      if (this.participant == null) return null;
      let title = sprintf(this.$t('event.dlgEditTitle'), this.participant.name);
      return title;
    },
  },
  methods: {
    content(value) {
      if (!value) {
        return '';
      }
      const inputElement = '<input class="md-input" />';
      return String(value).replace('{i}', inputElement);
    },

    openModal(participant, event) {
      console.log('Open modal', participant);
      this.participant = participant;
      this.eventChoice.comment = participant.comment;
      this.eventChoice.guests = participant.guests;
      this.eventChoice.answer = participant.choice;
      this.$refs.dlgEditEventChoice.openModal(event);
    },
    updateChoice() {
      const guestsElement = document.getElementById('md-event-guest');

      let participant = this.participant;
      if (guestsElement) {
        const guests = guestsElement.value;
        this.eventChoice.guests = guests;
        participant.guests = Number(this.eventChoice.guests);
        console.info('updateChoice - check guests:', participant.guests);
        if (participant.guests > this.poll.options.guestsLimit) {
          console.info('above guest limit');
          this.eventChoice.guests = 1;
          this.$nextTick(() => {
            this.eventChoice.guests = this.poll.options.guestsLimit;
          });
          return;
        }
      }
      participant.comment = this.eventChoice.comment;
      participant.choice = this.eventChoice.answer;
      if (!participant.guests) participant.guests = 0;
      if (isNaN(participant.guests)) {
        participant.guests = 0;
      }
      if (participant.choice != 2) {
        participant.guests = 0;
      }
      participant.guests = Math.floor(participant.guests);
      console.log('Update choice for participant:', participant);
      this.$emit('update', participant);
      this.$refs.dlgEditEventChoice.closeModal();
    },
    onCancel() {
      this.$refs.dlgEditEventChoice.closeModal();
    },
  },

  mounted() {},
};
</script>

<style lang="scss">
@import '@/styles/colors.scss';
</style>
